import {
  trimToLowerCase
} from '../common/functions';
import { variables } from '../common/variables';
import { map, markersCluster } from './leaflet/leaflet__map-init';
import { tagFilterButtonCustom } from './leaflet/leaflet-tag-filter-button--custom'

const createFilters = (mapArray, mapArrayType, mapArrayTypeTitle, mapArraySubType, group) => {
  /*------------ [FILTERS] ------------*/
  //creation d'une array clean pour creer les filtres
  const createFilterArray = () => {
    mapArray["0"] = mapArrayType;
    const mapArrayLowerCase = [];
    for (let i = 0; i < mapArray.length; i++) {
      if (mapArray[i][0] !== null) {
        mapArrayLowerCase.push(
          `optGroup__separator--${trimToLowerCase(
            mapArrayTypeTitle[i]
          )}`
        );
      }
      for (let j = 0; j < mapArray[i].length; j++) {
        if (mapArray[i][j] !== null) {
          if (mapArray[i][j].icon) {
            mapArrayLowerCase.push(
              {
                id: mapArray[i][j].id,
                name: trimToLowerCase(mapArray[i][j].name),
                icon: mapArray[i][j].icon
              }
            );
          } else {
            mapArrayLowerCase.push(trimToLowerCase(mapArray[i][j].name));
          }
        }
      }
    }
    return mapArrayLowerCase;
  };

  const createSubFiltersArray = () => {
    const subTypeSortedArray = []

    const parentIdArray = []
    if (mapArraySubType.length) {
      mapArraySubType.forEach(subType => {
        const parentId = subType.parent_id
        if (!parentIdArray.includes(parentId)) {
          parentIdArray.push(parentId)
        }
      })

      if (parentIdArray.length) {
        parentIdArray.forEach(parentId => {
          const sortedByParentId = mapArraySubType.filter(subType => {
            subType.label = subType.label
            return subType.parent_id === parentId;
          })

          let parentName = mapArrayType.filter(type => {
            return type.id === parentId
          })
          if (parentName[0]) {
            parentName = parentName[0].name
          }

          subTypeSortedArray.push(
            {
              parentName: parentName,
              parentId: parentId,
              subTypes: sortedByParentId
            }
          )
        });
      }
    }
    return subTypeSortedArray;
  };

  /*------------ [LEAFLET] ------------*/
  // Filtres event
  let statusFilterButton = tagFilterButtonCustom({
    data: {
      filters: createFilterArray(),
      subfilters: createSubFiltersArray()
    },
    header: `Catégories`,
    clearText: 'Réinitialiser',
    filterOnEveryClick: true,
    container: window.innerWidth >= variables.breakpoint ? "#map__stores .stores__search-filters__filters" : "#searchTab .stores__search-filters__filters",
    subContainer: window.innerWidth >= variables.breakpoint ? "#map__stores .stores__search-filters__subfilters" : "#searchTab .stores__search-filters__subfilters",
    storeItemSelector: '.container__item',
    onSelectionComplete: function (tags) {
      map.fitBounds(group.getBounds().pad(0));
    }
  })
    .addTo(map);
  // Enable MCG integration
  statusFilterButton.enableMCG(markersCluster);
}

export { createFilters };
